<script>
    import IconShow from '@/components/icon/IconShow.vue';

    export default {
        props: {
            game: Object,
        },
        components: {
            IconShow: IconShow
        },
        methods: {
            async clickGame() {
                this.$store.commit('PAG_GAME_EDIT_SET', this.game);
                this.$store.commit('IS_SHOW_PAG_GAME_EDIT', true);
            }
        }
    }
</script>


<template>
    <li @click="clickGame">
        <div 
            class="blur_white cursor_pointer_label"
        >
            <label
                class="ml_5"
            >[{{ game['id'] }}]</label>
            <IconShow 
                v-if="game['is_default'] === true"
                class="ml_5"
                iconWidth = "14px"
                iconHeight = "14px"
            />
            <label
                class="ml_5"
            >{{ game['name'] }}</label>
        </div>
    </li>
</template>